/**
 * HeroChatInput — the branded chat composer shared by the dashboard landing
 * and the conversation screen: the hero-variant ConversationInput box with the
 * wave texture rendered behind it, poking out below.
 *
 * Self-contained: it owns its own max-width + centering so the wave (which
 * spans the wrapper) and the input always line up, regardless of how wide the
 * parent is. Callers pass the same props they'd pass to ConversationInput
 * (minus `variant`/`sticky`, which this component fixes).
 */

import {
  ConversationInput,
  type ConversationInputProps,
} from '@/lib/reasoning/ConversationInput';

import { WaveInputFooter } from './WaveInputFooter';

export type HeroChatInputProps = Omit<
  ConversationInputProps,
  'variant' | 'sticky'
>;

export function HeroChatInput(props: HeroChatInputProps) {
  return (
    // Owns width + centering so the wave lines up with the input in any parent.
    // No padding on this positioned element — the wave (inset-x-0) spans it, so
    // it must equal the input width exactly. The wave is the first child so
    // paint order puts it behind the (opaque) input; mb-14 reserves room for
    // the wave overhang.
    <div className='relative mx-auto mb-14 w-full max-w-3xl text-left'>
      <WaveInputFooter />
      <div className='relative'>
        <ConversationInput {...props} variant='hero' sticky={false} />
      </div>
    </div>
  );
}
